var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.399,
    height: 11.313,
    viewBox: "0 0 12.399 11.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-envelope-message-padlock-locked-secured-svgrepo-com",
    transform: "translate(0.688 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M3,10l5.108,3.143L13.216,10",
    transform: "translate(-3 -8.035)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1972",
    "data-name": "Rectangle 1972",
    width: 4.62,
    height: 3.003,
    transform: "translate(6.591 7.311)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M24.75,20.2H22v-.918A1.349,1.349,0,0,1,23.375,18h0a1.349,1.349,0,0,1,1.375,1.285Z",
    transform: "translate(-14.534 -12.892)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M7.992,13.644H4.572A1.576,1.576,0,0,1,3,12.073v-5.5A1.576,1.576,0,0,1,4.572,5h7.073a1.576,1.576,0,0,1,1.572,1.572v2.09",
    transform: "translate(-3 -5)",
    fill: "none",
    stroke: "#afaeaf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSmallIcon);
export default __webpack_public_path__ + "static/media/email-small-icon.fe515952a651ba27d9480e8a8ddcd75b.svg";
export { ForwardRef as ReactComponent };